// Общая обёртка над Telegram WebApp.openInvoice — экраны 2 «Оформление подписки» и 5 «Смена
// тарифа» оба открывают Telegram-инвойс и одинаково понимают результат. Вынесено сюда после
// появления второго потребителя (тот же принцип, что и src/hooks/useSubscription.ts).
import WebApp from "@twa-dev/sdk";

// @twa-dev/types (7.10.0, установленная версия) ещё не описывает openInvoice, хотя рантайм-шим
// того же пакета его уже реализует (Bot API это поддерживает с версии 6.1) — локальный каст вместо
// ожидания апдейта пакета.
export type InvoiceStatus = "paid" | "failed" | "pending" | "cancelled";

export const openInvoice = (
  WebApp as unknown as {
    openInvoice: (url: string, callback: (status: InvoiceStatus) => void) => void;
  }
).openInvoice;
